import { Component } from '@angular/core';

@Component({
  selector: 'app-device-configuration-success',
  standalone: true,
  imports: [],
  templateUrl: './device-configuration-success.component.html',
  styleUrl: './device-configuration-success.component.css'
})
export class DeviceConfigurationSuccessComponent {

}
